// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'fr': 'fr', 'es': 'es', 'en': 'en', 'zh-CN': 'zh-CN'},
        displayType: "language_name",
        fontColor: "#000000",
        backgroundColor: "#E1DED2",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "GB",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "United Kingdom", "code": "GB", "currency": {"code": "GBP", "symbol": "\u00a3"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Espa\u00f1ol": {"name": "Espa\u00f1ol (Spanish)", "native_name": "Espa\u00f1ol", "code": "es", "default": false}, "\u7b80\u4f53\u4e2d\u6587": {"name": "\u7b80\u4f53\u4e2d\u6587 (Simplified Chinese)", "native_name": "\u7b80\u4f53\u4e2d\u6587", "code": "zh-CN", "default": false}, "Fran\u00e7ais": {"name": "Fran\u00e7ais (French)", "native_name": "Fran\u00e7ais", "code": "fr", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        